import GraphQL from '@app/model/_common/service/GraphQL';
import { PRINCIPAL_FRAGMENT } from '@app/model/authentication/service/AuthorizationGraphQlFragments';
import { gql } from 'graphql-request';
import {
    PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT
} from '@app/model/process-request/service/ProcessRequestGraphQLFragments';


export const CHECK_EMAIL_OR_USERNAME_EXISTS_QUERY: GraphQL = {
    name: "checkEmailOrUsernameExists",
    gql: gql`
        query checkEmailOrUsernameExists($username: String!) {
            checkEmailOrUsernameExists(username: $username) {
                success
                exception
            }
        }
    `
}

export const REGISTER_MUTATION: GraphQL = {
    name: "register",
    gql: gql`
        mutation register($input: RegistrationInput!) {
            register(input: $input) {
                success
                exception
            }
        }
    `
}

export const REGISTER_COMPANY_MUTATION: GraphQL = {
    name: "registerCompany",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation registerCompany($input: CompanyRegistrationInput!) {
            registerCompany(input: $input) {
                ...PrincipalFields
            }
        }
    `
}
export const PROFILE_VERIFICATION_PENDING_BY_USERNAME_QUERY: GraphQL = {
    name: "findPendingProfileVerificationByUsername",
    gql: gql`
        query findPendingProfileVerificationByUsername($username: String!) {
            findPendingProfileVerificationByUsername(username: $username) {
                key
                state
                profile {
                    email
                }
            }
        }
    `
}

export const PROFILE_VERIFICATION_PENDING_BY_ID_QUERY: GraphQL = {
    name: "findPendingProfileVerificationById",
    gql: gql`
        query findPendingProfileVerificationById($id: Long!) {
            findPendingProfileVerificationById(id: $id) {
                key
                state
                profile {
                    email
                }
            }
        }
    `
}

export const VERIFY_PROFILE_MUTATION: GraphQL = {
    name: "verifyProfile",
    gql: gql`
        mutation verifyProfile($verificationKey:String!) {
            verifyProfile(verificationKey: $verificationKey) {
                success
                exception
            }
        }
    `
}
export const CREATE_COMPANY_HOTEL_PROPERTIES_MUTATION: GraphQL = {
    name: "createCompanyHotelProperties",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation createCompanyHotelProperties($input:CompleteRegistrationInput!) {
            createCompanyHotelProperties(input:$input) {
                ...PrincipalFields
            }
        }
    `
}

export const CREATE_PARITY_COMPANY_HOTEL_MUTATION: GraphQL = {
    name: "createParityCompanyHotel",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation createParityCompanyHotel($hotelId: Long!, $webhotelierId: String!) {
            createParityCompanyHotel(hotelId: $hotelId, webhotelierId: $webhotelierId) {
                ...PrincipalFields
            }
        }
    `
}

export const RUN_ENRICH_COMPANY_HOTELS: GraphQL = {
    name: "runEnrichCompanyHotels",
    gql: gql`
        ${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
        mutation runEnrichCompanyHotels {
            runEnrichCompanyHotels {
               ...ProcessRequestExecutionStateFields
            }
        }
    `
}

export const RUN_RANKING_COMPANY_HOTELS: GraphQL = {
    name: "runRankingCompanyHotels",
    gql: gql`
        ${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
        mutation runRankingCompanyHotels {
            runRankingCompanyHotels {
                ...ProcessRequestExecutionStateFields
            }
        }
    `
}

export const RUN_UPDATE_MARKET_STATE_FOR_COMPANY: GraphQL = {
    name: "runMarketStateUpdateForCompany",
    gql: gql`
        ${PROCESS_REQUEST_EXECUTION_STATE_FRAGMENT}
        mutation runMarketStateUpdateForCompany {
            runMarketStateUpdateForCompany {
                ...ProcessRequestExecutionStateFields
            }
        }
		`
}


export const FINISH_UPDATE_MARKET_STATE_FOR_COMPANY: GraphQL = {
    name: "finishMarketStateUpdateForCompany",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation finishMarketStateUpdateForCompany {
            finishMarketStateUpdateForCompany {
                ...PrincipalFields
            }
        }
    `
}


export const SELECT_SUBSCRIPTION_PLAN_MUTATION: GraphQL = {
    name: "selectSubscriptionPlan",
    gql: gql`
        ${PRINCIPAL_FRAGMENT}
        mutation selectSubscriptionPlan {
            selectSubscriptionPlan {
                ...PrincipalFields
            }
        }
    `
}